import { useSession } from 'next-auth/react';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const sendClickEvent = async (url: string, payload: Payload) =>
  await api.post(url, { ...payload, origin: 'web' });

export const useSendClickEvent = () => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.customer.sendClick
      : apiConfig.routes.customer.sendClickPublic;

  return useMutation({
    mutationFn: (payload: Payload) => sendClickEvent(url, payload),
  });
};

type Payload = { label: string; is_pre_home?: boolean };
